import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaTimes, FaRegCopy, FaCheck } from "react-icons/fa";
import cartAPI from "../api/cartApi";

const SEEN_KEY = "coupon_popup_seen";
// in pages pe popup nahi dikhana
const HIDE_ON = ["/cart", "/checkout", "/order-confirmation"];

// example ke liye base price (sirf dikhane ke liye)
const EXAMPLE_PRICE = 1000;
const PREPAID_TEXT = "Extra 5% off on prepaid orders";

const offerText = (c) => {
  if (!c?.discountValue) return "";
  return c.discountType === "PERCENTAGE"
    ? `${c.discountValue}% OFF`
    : `FLAT ₹${c.discountValue} OFF`;
};

const getDiscountedPrice = (c, base = EXAMPLE_PRICE) => {
  if (!c?.discountValue) return base;
  const off =
    c.discountType === "PERCENTAGE"
      ? (base * c.discountValue) / 100
      : c.discountValue;
  return Math.max(0, Math.round(base - off));
};

function CouponPopup() {
  const { pathname } = useLocation();
  const [coupons, setCoupons] = useState([]);
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState("");

  // website khulte hi (session mein ek hi baar) coupons fetch karo
  useEffect(() => {
    if (sessionStorage.getItem(SEEN_KEY)) return;
    if (HIDE_ON.some((p) => pathname.startsWith(p))) return;

    let timer;
    const load = async () => {
      try {
        const res = await cartAPI.showCoupon();
        if (res.code === 200 && Array.isArray(res.data) && res.data.length) {
          setCoupons(res.data);
          timer = setTimeout(() => setOpen(true), 800);
        }
      } catch (err) {}
    };
    load();

    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, []);

  // popup khula ho to background scroll band + ESC se close
  useEffect(() => {
    if (!open) return;
    document.body.style.overflow = "hidden";
    const onKey = (e) => e.key === "Escape" && close();
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
    // eslint-disable-next-line
  }, [open]);

  const close = () => {
    sessionStorage.setItem(SEEN_KEY, "1");
    setOpen(false);
  };

  const copyCode = async (code) => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(code);
      setTimeout(() => setCopied(""), 1800);
    } catch (e) {}
  };

  if (!open || !coupons.length) return null;

  const [main, ...others] = coupons;
  const extra = others.slice(0, 2);
  const hasOffer = !!main.discountValue;

  return (
    <div className="cp-overlay" onClick={close}>
      <div
        className="cp-modal"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="cp-close" onClick={close} aria-label="Close">
          <FaTimes size={14} />
        </button>

        <div className="cp-top">
          <span className="cp-eyebrow">Welcome to Ivoréa ✦</span>
          <h2 className="cp-offer">10% OFF</h2>
          <p className="cp-title">Get 10% Off On Your First Order</p>
        </div>

        <div className="cp-body">
          {/* discounted price example */}
          {/* {hasOffer && (
            <div className="cp-price-box">
              <div className="cp-price-row">
                <span className="cp-price-old">
                  ₹{EXAMPLE_PRICE.toLocaleString("en-IN")}
                </span>
                <span className="cp-price-new">
                  ₹{getDiscountedPrice(main).toLocaleString("en-IN")}
                </span>
              </div>
            </div>
          )} */}

          {/* backend wala coupon code + copy */}
          {main.code && (
            <>
              <p className="cp-label">Get Extra 5% Off On Prepaid Orders</p>
              <p className="cp-label">Use this code at checkout</p>
              <div className="cp-code-box">
                <span className="cp-code">FIRSTORDER10</span>
                <button
                  type="button"
                  className="cp-copy"
                  onClick={() => copyCode(main.code)}
                >
                  {copied === main.code ? (
                    <>
                      <FaCheck size={12} /> Copied
                    </>
                  ) : (
                    <>
                      <FaRegCopy size={12} /> Copy
                    </>
                  )}
                </button>
              </div>
            </>
          )}

          {/* prepaid extra offer */}
          {/* <div className="cp-prepaid">{PREPAID_TEXT}</div> */}

          {/* baaki coupons (max 2) */}
          {/* {extra.length > 0 && (
            <div className="cp-more">
              {extra.map((c) => (
                <div className="cp-more-item" key={c._id || c.code}>
                  <span className="cp-more-code">{c.code}</span>
                  <span className="cp-more-text">
                    {offerText(c) || c.title}
                  </span>
                </div>
              ))}
            </div>
          )} */}

          <Link to="/shop" className="cp-shop-btn" onClick={close}>
            Shop Now
          </Link>
          <button className="cp-skip" onClick={close}>
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
}

export default CouponPopup;